export default __webpack_public_path__ + "static/averti_infotech-57d475c2ba205dd27b804e5f2639d5ea.jpg";